import app from 'flarum/forum/app';
import { extend, override } from 'flarum/common/extend';
import DiscussionList from 'flarum/forum/components/DiscussionList';
import IndexPage from 'flarum/forum/components/IndexPage';
import CommentPost from 'flarum/forum/components/CommentPost';
import classList from 'flarum/common/utils/classList';

import NwcTrackerFeed from './components/NwcTrackerFeed';
import { highlightEnabled, isTrackedUser, isTrackerTagSlug } from '../common/tracker';

function onTrackerTagPage() {
  return app.current.matches(IndexPage) && isTrackerTagSlug(m.route.param('tags'));
}

app.initializers.add('mnm-nwc-tracker', () => {
  // 1. Replace the discussion list on the tracker tag's page with the feed.
  override(DiscussionList.prototype, 'view', function (original, ...args) {
    if (this.attrs.state === app.discussions && onTrackerTagPage()) {
      return <NwcTrackerFeed />;
    }

    return original(...args);
  });

  // Sorting / refreshing discussions makes no sense on the feed.
  extend(IndexPage.prototype, 'viewItems', function (items) {
    if (onTrackerTagPage() && items.has('sort')) items.remove('sort');
  });

  extend(IndexPage.prototype, 'actionItems', function (items) {
    if (onTrackerTagPage() && items.has('refresh')) items.remove('refresh');
  });

  // 2. Highlight tracked authors' posts inside discussions.
  extend(CommentPost.prototype, 'elementAttrs', function (attrs) {
    if (highlightEnabled() && isTrackedUser(this.attrs.post.user())) {
      attrs.className = classList(attrs.className, 'Post--nwc');
    }
  });

  extend(CommentPost.prototype, 'headerItems', function (items) {
    if (highlightEnabled() && isTrackedUser(this.attrs.post.user())) {
      items.add(
        'nwc',
        <span className="NwcBadge" title={app.translator.trans('mnm-nwc-tracker.forum.badge.tooltip')}>
          {app.translator.trans('mnm-nwc-tracker.forum.badge.label')}
        </span>,
        90
      );
    }
  });
});
